export const ROUTE_SIGNUP = 'signup';
export const ROUTE_SIGNUP_COMPLETED = 'signup-completed';
export const ROUTE_SIGNUP_ERROR = 'signup-error';
export const ROUTE_SIGNIN = 'signin';
export const ROUTE_TERMS_CONDITIONS='terms-conditions';
export const ROUTE_PRIVACY_STATEMENT='privacy-statement';
